/****************************************************
 * Module Name:  tallyGrading.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useRef, useState } from "react";
import Constants from "../../utility/constants";
import { DataGridPro, GridToolbarExport, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { Box, Button, Container, Menu, MenuItem, Tooltip, IconButton, Stack, Typography } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import Utility from "../../utility/utility";
import { useEffect } from "react";
import StoneDetailModal from "../common/stoneDetailModal";
import { alpha, styled } from "@mui/material/styles";
import NoPermission from "../common/noPermission";
import StockTallyProxy from "../../utility/proxy/manager/stockTallyProxy";
import CommonStoneSelection from "../common/commonStoneSelection";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { BackupTable } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import Papa from 'papaparse';
import UploadFileIcon from "@mui/icons-material/UploadFile";
import colourchart from '../../images/ColorScheme.png';
import EditIcon from '@mui/icons-material/Edit';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import KapanHistoryModal from "../manufacturing/operations/kapanHistoryModal";
import TableIncProxy from "../../utility/proxy/manager/tableIncProxy";
import SideIncProxy from "../../utility/proxy/manager/sideIncProxy";
import HNAProxy from "../../utility/proxy/manager/hnaProxy";
import EyecleanProxy from "../../utility/proxy/manager/eyecleanProxy";
import TingeProxy from "../../utility/proxy/manager/tingeProxy";
import OpenProxy from "../../utility/proxy/manager/openProxy";
import MilkyProxy from "../../utility/proxy/manager/milkyProxy";
import LusterProxy from "../../utility/proxy/manager/lusterProxy";
import PageTitle from "../common/pageTitle";
import { VscRunAll } from "react-icons/vsc";
import StoneProxy from "../../utility/proxy/manager/stoneProxy";

const StyledDataGrid = styled(DataGridPro)(({ theme }) => ({
    "& .super-app-theme--NEW": {
        backgroundColor: "#F9F08D",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#F9F08D",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--LAB": {
        backgroundColor: "#7EAEEE",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#7EAEEE",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
            color: "black",
        },
    },
    "& .super-app-theme--RE-LAB": {
        backgroundColor: "#FCCD91",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#FCCD91",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--RE-CHECK": {
        backgroundColor: "#FFFFCC",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#FFFFCC",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--RE-CHECK_SENT": {
        backgroundColor: "#B8ACF6",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#B8ACF6",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--RE-CHECK_DONE": {
        backgroundColor: "#388BFF",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#388BFF",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--MIX": {
        backgroundColor: "#E0E88C",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#E0E88C",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--AVAILABLE_APPROVAL_PENDING": {
        backgroundColor: "#FBDEDE",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#FBDEDE",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--AVAILABLE": {
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--HOLD": {
        backgroundColor: "#B6B9D6",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#B6B9D6",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--MEMO_OUT": {
        backgroundColor: "#CAF7F6",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#CAF7F6",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--LOCATION_SENT": {
        backgroundColor: "#FEBD7D",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#FEBD7D",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    '& .MuiDataGrid-columnHeader': {
        color: '#fff',
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        backgroundColor: 'grey',
    },
    "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
        py: "8px",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
    },
    "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
        py: "15px",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
    },
    "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
        py: "22px",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
    },

}));

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color:
            theme.palette.mode === 'light'
                ? 'rgb(55, 65, 81)'
                : theme.palette.grey[300],
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity
                ),
            },
        },
    },
}));

export default function TallyGrading() {
    const { apiRef, handleCellClick } = Utility.useSingleClickEdit();
    const stockTallyPermission = Constants.USER_PERMISSION.filter((iPermission) =>
        iPermission.permissionid === Constants.PERMISSIONS.OPERATION_STOCKTALLY);

    const [stockData, setStockData] = useState([]);
    const [stockLoader, setStockLoader] = useState(false);
    const [selectionModel, setSelectionModel] = useState([]);
    const [stoneId, setStoneId] = useState("");
    const [showStoneDetailModal, setShowStoneDetailModal] = useState(false);
    const [successSnackbar, setSuccessSnackbar] = useState(false);
    const [errorSnackbar, setErrorSnackbar] = useState(false);
    const [noOfSelectedStones, setNoOfSelectedStones] = useState("0");
    const [selectedTotalSize, setSelectedTotalSize] = useState("0");
    const [selectedAvgDiscount, setSelectedAvgDiscount] = useState("0");
    const [selectedavgPrice, setSelectedavgPrice] = useState("0");
    const [selectedtotalPrice, setSelectedtotalPrice] = useState("0");
    const [sortModel, setSortModel] = React.useState([]);
    const [alertSnackbar, setAlertSnackbar] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [uploadLoader, setUploadLoader] = useState(false);
    const [uploadSuccessSnackbar, setUploadSuccessSnackbar] = useState(false);
    const [stoneDataMap, setStoneDataMap] = useState({});
    const [applyLoader, setApplyLoader] = useState(false);
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarVariant, setSnackbarVariant] = useState("");
    const [kapanId, setKapanId] = useState("");
    const [showKapanDetailModal, setShowKapanDetailModal] = useState(false);

    const [tableincOptions, setTableIncOptions] = useState([]);
    const [sideincOptions, setSideIncOptions] = useState([]);
    const [hnaOptions, setHnaOptions] = useState([]);
    const [eyecleanOptions, setEyeCleanOptions] = useState([]);
    const [tingeOptions, setTingeOptions] = useState([]);
    const [openOptions, setOpenOptions] = useState([]);
    const [milkyOptions, setMilkyOptions] = useState([]);
    const [lusterOptions, setLusterOptions] = useState([]);
    const [filterValues, setFilterValues] = useState({});
    const [openDropdown, setOpenDropdown] = useState(true);

    const [extraPacket, setExtraPacket] = useState([]);
    const extraPacketRef = useRef(extraPacket);

    useEffect(() => {
        extraPacketRef.current = extraPacket;
    }, [extraPacket]);

    // Create a connection
    const ws = useRef(null);

    const startScanning = () => {

        if (!ws.current) {
            ws.current = new WebSocket(Constants.RFID_API);
        }

        // Open WebSocket connection and start scanning
        if (!ws.current || ws.current.readyState === WebSocket.CLOSED) {
            // WebSocket doesn't exist or was closed — create new one
            ws.current = new WebSocket(Constants.RFID_API);
            ws.current.onopen = () => {
                ws.current.send("START_SCAN");
            };
        } else if (ws.current.readyState === WebSocket.CONNECTING) {
            // Still connecting — safely attach onopen
            ws.current.onopen = () => {
                ws.current.send("START_SCAN");
            };
        } else if (ws.current.readyState === WebSocket.OPEN) {
            // Already open — send immediately
            ws.current.send("START_SCAN");
        }

        // Listen for incoming messages from WebSocket
        let lstTags = new Set();
        ws.current.onmessage = (e) => {
            let message = typeof e.data === 'string' ? e.data : String(e.data);
            if (message.includes("TAG: ")) {
                const parts = message.split("TAG: ");
                if (parts.length === 2) {
                    const remaining = parts[1].trim(); // remove extra whitespace
                    remaining.split(',').forEach(str => lstTags.add(str.trim())); // split and trim each item
                }

                if (stockData.length > 0) {
                    setTagsSelections(lstTags);
                }
            } else if (message.includes("SCAN_COMPLETED")) {
                ws.current.close();
                ws.current.onclose = () => {
                    getStoneIdByTagId();
                }
            }
        };
    }

    const setTagsSelections = (tags) => {
        //tags is array or string which are tag sample ['t1','t2']
        let lStockData = stockData;
        let iNewSelected = 0;
        let iUnSelectedTags = 0;
        let selectedCheckBox = [];
        let tagsFound = [];
        let tagsNotFound = [];

        for (let loopCnt = 0; loopCnt < lStockData.length; loopCnt++) {
            if (lStockData[loopCnt].tag && tags.has(lStockData[loopCnt].tag)) {
                selectedCheckBox.push(lStockData[loopCnt].stoneid);
                tagsFound.push(lStockData[loopCnt].tag);
                iNewSelected++;
            }
        }

        tagsNotFound = [...tags].filter(tag => !tagsFound.includes(tag));
        iUnSelectedTags = tags.size - iNewSelected;

        setStockData(() => {
            let selectedStone = [];
            let unSelectedStone = [];
            lStockData.forEach((res) => {
                if (selectedCheckBox.includes(res.stoneid)) {
                    selectedStone.push(res);
                } else {
                    unSelectedStone.push(res);
                }
            });
            return [...selectedStone, ...unSelectedStone];
        });
        setSelectionModel(selectedCheckBox);
        if (tagsNotFound.length > 0) {
            setExtraPacket(prev => Array.from(new Set([...prev, ...tagsNotFound])));
        }

        return {
            NewSelectedStones: iNewSelected,
            UnusedTags: iUnSelectedTags,
        };
    };

    const getStoneIdByTagId = () => {
        if (extraPacketRef.current.length > 0) {
            StoneProxy.GetStoneIdByTagId(extraPacketRef.current, (response) => {
                if (response) {
                    let resultString = Object.entries(response)
                        .map(([stoneid, tag]) => `${stoneid}: ${tag}`)
                        .join(', ');

                    if (Object.entries(response).length < extraPacketRef.current.length) {
                        const usedTags = new Set(Object.values(response));
                        const extraTags = extraPacketRef.current.filter(tag => !usedTags.has(tag));

                        const extraTagString = extraTags.map(tag => `STONE_ID: ${tag}`).join(', ');
                        resultString = resultString + ', ' + extraTagString;
                    }

                    setShowSnackbar(true);
                    setSnackbarMessage(`You have ${resultString} extra package on your RF Machine`);
                    setSnackbarVariant("error");
                    setExtraPacket([]);
                    ws.current = null;
                } else {
                    setShowSnackbar(true);
                    setSnackbarMessage(Constants.APiFailErrorMessage);
                    setSnackbarVariant("error");
                    ws.current = null;
                    setExtraPacket([]);
                }
            })
        }
    }

    const handleSearch = () => {

        setStockLoader(true);
        let userLocationId = Constants.loggedInUser.locationid;
        let data = {
            status: ["MIX", "SELL", "SELL_SENT", "SOLD"],
            boxids: []
        }
        StockTallyProxy.GetAllStockForGrading(userLocationId, data, (response) => {
            if (response) {
                const distinctStatus = Utility.getDistinctOptions(response, 'status');
                setFilterValues(distinctStatus);
                setStockData(response);
                setStockLoader(false);
                if (selectionModel.length <= 0)
                    loadTotalData(response);
            } else {
                setStockLoader(false);
                setErrorSnackbar(true);
            }
        })
    };

    useEffect(() => {
        PageTitle("OPERATION_STOCKTALLY_GRADING");
        handleSearch();
        getAllGradingFields();
    }, []);

    const getAllGradingFields = () => {

        // Table Inc Options
        TableIncProxy.GetAllTableInc(response => {
            if (response) {
                setTableIncOptions(response.sort((a, b) => a.seq - b.seq).map(iResponse => iResponse.name));
            }
        });

        // Side Inc Options
        SideIncProxy.GetAllSideInc(response => {
            if (response) {
                setSideIncOptions(response.sort((a, b) => a.seq - b.seq).map(iResponse => iResponse.name));
            }
        });

        // H and A Options
        HNAProxy.GetAllHNA(response => {
            if (response) {
                setHnaOptions(response.sort((a, b) => a.seq - b.seq).map(iResponse => iResponse.name));
            }
        })

        // Eyeclean Options
        EyecleanProxy.GetAllEyeclean(response => {
            if (response) {
                setEyeCleanOptions(response.sort((a, b) => a.seq - b.seq).map(iResponse => iResponse.name));
            }
        })

        // Tinge Options
        TingeProxy.GetAllTinge(response => {
            if (response) {
                setTingeOptions(response.sort((a, b) => a.seq - b.seq).map(iResponse => iResponse.name));
            }
        })

        // Open Options
        OpenProxy.GetAllOpen(response => {
            if (response) {
                setOpenOptions(response.sort((a, b) => a.seq - b.seq).map(iResponse => iResponse.name));
            }
        })

        // Milky Options
        MilkyProxy.GetAllMilky(response => {
            if (response) {
                setMilkyOptions(response.sort((a, b) => a.seq - b.seq).map(iResponse => iResponse.name));
            }
        })

        // Luster Options
        LusterProxy.GetAllLuster(response => {
            if (response) {
                setLusterOptions(response.sort((a, b) => a.seq - b.seq).map(iResponse => iResponse.name));
            }
        })

    };

    useEffect(() => {
        let stockMap = new Map();
        if (stockData.length !== 0) {
            stockData.forEach(iData => {
                stockMap.set(iData.stoneid, iData);
            })
            setStoneDataMap(stockMap);
        }
    }, [stockData])

    const handleClose = () => {
        setShowStoneDetailModal(false);
    };

    const handleStoneDetailModal = (params) => {
        setStoneId(params.value);
        setShowStoneDetailModal(true);
    };

    const handleSelection = (data) => {
        const [tempStockData, tempSelectionModel] = Utility.handleSelection(data, stockData, selectionModel);

        setStockData(tempStockData);
        setSelectionModel(tempSelectionModel);
    }

    const loadTotalData = (data) => {
        let totalSize = 0;
        let totalPrice = 0;   //ppc*size
        let total = 0;       //rapnetprice*size

        data.forEach((iData) => {
            let pricePerCarat = iData.price
            totalSize += iData.size;
            totalPrice += (iData.size * pricePerCarat);
            total += (iData.size * ((100 * pricePerCarat) / (100 + iData.discount)));

        });
        setNoOfSelectedStones(data.length);
        setSelectedTotalSize(Utility.ConvertNumberWithSpecifiedDigits(totalSize));
        setSelectedtotalPrice(Utility.ConvertNumberWithSpecifiedDigits(totalPrice));
        setSelectedavgPrice(
            totalPrice > 0
                ? Utility.ConvertNumberWithSpecifiedDigits(
                    totalPrice / totalSize
                )
                : Utility.ConvertNumberWithSpecifiedDigits(0)
        );
        setSelectedAvgDiscount(
            totalPrice > 0
                ? Utility.ConvertNumberWithSpecifiedDigits(
                    (100 - (totalPrice / total) * 100) * -1
                )
                : Utility.ConvertNumberWithSpecifiedDigits(0)
        );
    };

    useEffect(() => {
        if (selectionModel.length <= 0) {
            loadTotalData(stockData);
            return;
        }
        let totalSize = 0;
        let totalPrice = 0;   //ppc*size
        let total = 0;       //rapnetprice*size
        stockData.forEach((iData) => {
            if (selectionModel.includes(iData.stoneid)) {
                let pricePerCarat = iData.price
                totalSize += iData.size;
                totalPrice += (iData.size * pricePerCarat);
                total += (iData.size * ((100 * pricePerCarat) / (100 + iData.discount)));
            }
        });
        setNoOfSelectedStones(selectionModel.length);
        setSelectedTotalSize(Utility.ConvertNumberWithSpecifiedDigits(totalSize));
        setSelectedtotalPrice(Utility.ConvertNumberWithSpecifiedDigits(totalPrice));
        setSelectedavgPrice(
            totalPrice > 0
                ? Utility.ConvertNumberWithSpecifiedDigits(
                    totalPrice / totalSize
                )
                : Utility.ConvertNumberWithSpecifiedDigits(0)
        );
        setSelectedAvgDiscount(
            totalPrice > 0
                ? Utility.ConvertNumberWithSpecifiedDigits(
                    (100 - (totalPrice / total) * 100) * -1
                )
                : Utility.ConvertNumberWithSpecifiedDigits(0)
        );
    }, [selectionModel]);

    const handleUpload = (file) => {
        const reader = new FileReader();
        reader.onload = () => {
            const text = reader.result;
            Papa.parse(text, {
                header: true,
                skipEmptyLines: true,
                complete: (result) => {
                    if (result.data.length <= 0) {
                        setAlertSnackbar(true);
                        setAlertMessage("No Stones Found");
                        return;
                    }

                    let headersFromCSV = Object.keys(result.data[0]);
                    let requiredColumns = ['Stone Id', 'surat id', 'Table Inc', 'Side Inc', 'H&A',
                        'Eye Clean', 'Tinge', 'Open', 'Milky', 'Luster'];
                    if (requiredColumns.length === headersFromCSV.length) {
                        let matchedList1 = [];
                        let matchedList2 = [];
                        let unmatchedList = [];
                        const stoneIdsInStockData = new Set();

                        result.data.forEach(record => {
                            stockData.forEach(row => {
                                if (row.stoneid === parseInt(record['Stone Id']) || row.suratid === record['surat id']) {
                                    let tableIncArr;
                                    let sideIncArr;
                                    // let h_and_aArr;
                                    // let openArr;
                                    // let milkyArr;
                                    // let lusterArr;

                                    if (record['Table Inc']) {
                                        tableIncArr = record['Table Inc'].split(",");
                                        tableIncArr = tableIncArr.filter(i => tableincOptions.includes(i.toUpperCase())).map(i => i.toUpperCase());
                                    }
                                    if (record['Side Inc']) {
                                        sideIncArr = record['Side Inc'].split(",");
                                        sideIncArr = sideIncArr.filter(i => sideincOptions.includes(i.toUpperCase())).map(i => i.toUpperCase());
                                    }
                                    // incase we want multiple values uncomment this part

                                    // if (record['H&A']) {
                                    //     h_and_aArr = record['H&A'].split(",");
                                    //     h_and_aArr = h_and_aArr.filter(i => hnaOptions.includes(i.toUpperCase())).map(i => i.toUpperCase());
                                    // }
                                    // if (record['Open']) {
                                    //     openArr = record['Open'].split(",");
                                    //     openArr = openArr.filter(i => openOptions.includes(i.toUpperCase())).map(i => i.toUpperCase());
                                    // }
                                    // if (record['Milky']) {
                                    //     milkyArr = record['Milky'].split(",");
                                    //     milkyArr = milkyArr.filter(i => milkyOptions.includes(i.toUpperCase())).map(i => i.toUpperCase());
                                    // }
                                    // if (record['Luster']) {
                                    //     lusterArr = record['Luster'].split(",");
                                    //     lusterArr = lusterArr.filter(i => lusterOptions.includes(i.toUpperCase())).map(i => i.toUpperCase());
                                    // }

                                    let iRow = {
                                        ...row,
                                        tableinc: tableIncArr.join(","),
                                        sideinc: sideIncArr.join(","),
                                        h_and_a: hnaOptions.includes(record['H&A'] || "") ? record['H&A'] : "",
                                        eyeclean: eyecleanOptions.includes(record['Eye Clean'] || "") ? record['Eye Clean'] : "",
                                        tinge: tingeOptions.includes(record['Tinge'] || "") ? record['Tinge'] : "",
                                        open: openOptions.includes(record['Open'] || "") ? record['Open'] : "",
                                        milky: milkyOptions.includes(record['Milky'] || "") ? record['Milky'] : "",
                                        luster: lusterOptions.includes(record['Luster'] || "") ? record['Luster'] : "",
                                        tableblack: tableIncArr.includes("B1") || tableIncArr.includes("B2") || tableIncArr.includes("B3"),
                                        sideblack: sideIncArr.includes("B1") || sideIncArr.includes("B2") || sideIncArr.includes("B3"),
                                        isEdited: true,
                                    }

                                    if (!iRow.tableinc || !iRow.sideinc || !iRow.h_and_a || !iRow.eyeclean || !iRow.tinge ||
                                        !iRow.open || !iRow.milky || !iRow.luster) {
                                        matchedList1.push(iRow);
                                    } else {
                                        matchedList2.push(iRow);
                                    }

                                    stoneIdsInStockData.add(row.stoneid);
                                }
                                return true;
                            });
                        });

                        //to add unmatched stones down in the selection model
                        stockData.forEach(iRow => {
                            if (!stoneIdsInStockData.has(iRow.stoneid)) {
                                unmatchedList.push(iRow);
                            }
                        });

                        setSelectionModel(Array.from(stoneIdsInStockData));
                        setStockData(matchedList1.concat(matchedList2).concat(unmatchedList));
                        setUploadLoader(false);
                        setUploadSuccessSnackbar(true);
                    } else {
                        console.error('CSV columns do not match table columns.');
                        setUploadLoader(false);
                        setUploadSuccessSnackbar(true);
                    }
                },
                error: (error) => {
                    console.error('Error parsing CSV:', error);
                    setAlertSnackbar(true);
                }
            });
        };

        reader.readAsText(file);
    };

    const handleClear = () => {
        const fileInput = document.getElementById('file-input');
        fileInput.value = null;
    }

    const handleProcessRowUpdateError = (error) => {
        // console.error(error);
    };

    const processRowUpdate = (newRow, oldRow) => {

        const changedFeilds = Utility.getChangedFields(newRow, oldRow);
        if (changedFeilds.length > 0) {
            let { id, field, value } = changedFeilds[0];

            let sideblack = newRow.sideblack;
            let tableblack = newRow.tableblack;

            if (value !== "") {
                if (field === 'tableinc') {
                    value = value.split(",")
                        .filter(i => tableincOptions.includes(i.toUpperCase()))
                        .map(i => i.toUpperCase())
                        .join(",");

                    tableblack = value.includes("B1") || value.includes("B2") || value.includes("B3");

                } else if (field === 'sideinc') {
                    value = value.split(",")
                        .filter(i => sideincOptions.includes(i.toUpperCase()))
                        .map(i => i.toUpperCase())
                        .join(",");

                    sideblack = value.includes("B1") || value.includes("B2") || value.includes("B3");

                } else if (field === 'h_and_a') {
                    value = hnaOptions.includes(value.toUpperCase() || "") ? value.toUpperCase() : "";
                } else if (field === 'eyeclean') {
                    value = eyecleanOptions.includes(value.toUpperCase() || "") ? value.toUpperCase() : "";
                } else if (field === 'tinge') {
                    value = tingeOptions.includes(value.toUpperCase() || "") ? value.toUpperCase() : "";
                } else if (field === 'open') {
                    value = openOptions.includes(value.toUpperCase() || "") ? value.toUpperCase() : "";
                } else if (field === 'milky') {
                    value = milkyOptions.includes(value.toUpperCase() || "") ? value.toUpperCase() : "";
                } else if (field === 'luster') {
                    value = lusterOptions.includes(value.toUpperCase() || "") ? value.toUpperCase() : "";
                }

                // incase we want multiple values uncomment this part

                // if (field === 'h_and_a') {
                //     value = value.split(",")
                //         .filter(i => hnaOptions.includes(i.toUpperCase()))
                //         .map(i => i.toUpperCase())
                //         .join(",");
                // }

                // if (field === 'open') {
                //     value = value.split(",")
                //         .filter(i => openOptions.includes(i.toUpperCase()))
                //         .map(i => i.toUpperCase())
                //         .join(",");
                // }

                // if (field === 'milky') {
                //     value = value.split(",")
                //         .filter(i => milkyOptions.includes(i.toUpperCase()))
                //         .map(i => i.toUpperCase())
                //         .join(",");
                // }

                // if (field === 'luster') {
                //     value = value.split(",")
                //         .filter(i => lusterOptions.includes(i.toUpperCase()))
                //         .map(i => i.toUpperCase())
                //         .join(",");
                // }
            }

            const updatedListData = stockData.map((iStone) => {
                if (iStone.stoneid === id && value) {
                    return { ...iStone, [field]: value, isEdited: true, sideblack: sideblack, tableblack: tableblack }
                }
                return iStone;
            })

            setStockData(updatedListData);

            const updatedRow = updatedListData.find(row => row.stoneid === id);
            return updatedRow;
        } else {
            // No changes detected, return the newRow to trigger exit edit mode
            return { ...newRow };
        }
    };

    const handleApply = () => {

        let data = [];
        let wrongData = [];
        const tingeMapping = {
            "": "None",
            none: "None",
            non: "None",
            gr1: "None",
            gr2: "None",
            mix: "Mixed",
            br: "Brown"
        };

        selectionModel.forEach((stoneid) => {
            const matchedRow = stoneDataMap.get(stoneid);

            if (matchedRow.tinge === undefined || matchedRow.tinge === null || !tingeMapping[(matchedRow.tinge).toLowerCase()] || !matchedRow.tableinc || !matchedRow.sideinc || !matchedRow.h_and_a || !matchedRow.eyeclean || !matchedRow.open || !matchedRow.milky || !matchedRow.luster) {
                wrongData.push(matchedRow.stoneid);
            } else {
                data.push(matchedRow);
            }
        })

        if (wrongData.length > 0) {
            setShowSnackbar(true);
            setSnackbarVariant("warning");
            setSnackbarMessage("Incomplete data for stoneids : " + wrongData + ".  Please fill correct details.");
        } else {
            setApplyLoader(true);
            StockTallyProxy.UpdateGradingStone(data, (response) => {
                if (response) {
                    setSuccessSnackbar(true);
                    handleSearch();
                    setSelectionModel([]);
                    setApplyLoader(false);
                } else {
                    setErrorSnackbar(true);
                    setApplyLoader(false);
                }
            })
        }
    }

    const columnsData = {
        "5dd43313-18b9-41a5-9e07-09d61ad6863c": {
            field: "stoneid",
            headerName: "STONEID",
            pinning: { position: 'left' },
            headerAlign: "center",
            align: "center",
            width: 80,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.NeedToShowStoneDetailModal() ?
                <Button
                    sx={{
                        textDecorationLine: "underline",
                        color: 'black'
                    }}
                    onClick={() => handleStoneDetailModal(params)}
                >
                    {params.value}
                </Button>
                :
                <div>{params.value}</div>,
        },
        "24ba0bf8-4ca1-4726-ad90-19a62c8c72e6": {
            field: "boxid",
            headerName: "BOXID",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 80
        },
        "9dfe5dd6-726c-465b-9f61-22fca6660b4f": {
            field: "kapanid",
            headerName: "KAPANID",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => (Utility.NeedToShowKapanDetailModal()) ?
                <Button
                    sx={{
                        textDecorationLine: "underline",
                        color: 'black'
                    }}
                    onClick={() => {
                        setKapanId(params.row.kapanid);
                        setShowKapanDetailModal(true);
                    }}
                >
                    {params.value}
                </Button>
                :
                <div>{params.value}</div>,
            width: 80,
        },
        "62c37a29-d2ff-4c72-8cb3-07e52a83d484": {
            field: "status",
            headerName: "STATUS",
            headerAlign: "center",
            align: "center",
            width: 140,
            valueGetter: (params) => (params.value === "MEMO_REQUESTED" ? "AVAILABLE" : params.value),
            renderCell: (params) => (params.value === "MEMO_REQUESTED" ? "AVAILABLE" : params.value),
            cellClassName: (params) => `super-app-theme--${params.row.status.toUpperCase()}`,
        },
        "52599510-9698-4cd3-90b7-7ac22b6af7e2": {
            field: "stonetype",
            headerName: "STONETYPE",
            headerAlign: "center",
            align: "center",
            width: 100,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.stonetype.map(option => option.fullname),
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => Constants.STONE_TYPE[params.value],
            renderCell: (params) => Constants.STONE_TYPE[params.value],
        },
        "eb5db767-47d2-4444-9b52-7dc35c853fc7": {
            field: "shape",
            headerName: "SHAPE",
            headerAlign: "center",
            align: "center",
            width: 80,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.shape.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "9f0b7352-8ca1-459d-944c-eb46dad5aed1": {
            field: "size",
            headerName: "SIZE",
            headerAlign: "center",
            width: 40,
            align: "right",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.size)
        },
        "fe7c00f1-774a-45a2-aec0-e5fb2ea1101e": {
            field: "color",
            headerName: "COLOR",
            headerAlign: "center",
            align: "center",
            width: 65,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.color.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "d4992de9-92ab-4f9e-ba12-6c746e935611": {
            field: "colordescriptions",
            headerName: "COLOR DESCRIPTIONS",
            headerAlign: "center",
            align: "center",
            width: 160,
            renderCell: renderCellExpand,
        },
        "1035d1d0-bc7c-404f-8f58-c80bea2de613": {
            field: "clarity",
            headerName: "CLARITY",
            headerAlign: "center",
            align: "center",
            width: 75,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.clarity.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "3597803f-8932-40c6-8de6-81006f4d6d5b": {
            field: "cut",
            headerName: "CUT",
            headerAlign: "center",
            align: "center",
            width: 50,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.cut.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "859c71c9-c9c8-4f2c-9eb7-08e388e505ad": {
            field: "pol",
            headerName: "POL",
            headerAlign: "center",
            align: "center",
            width: 40,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.pol.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "5541c182-21b8-496e-b342-b0b89f3d302f": {
            field: "sym",
            headerName: "SYM",
            headerAlign: "center",
            align: "center",
            width: 40,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.sym.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "8296e627-0be5-4a66-830f-ea6867cea137": {
            field: "flo",
            headerName: "FLO",
            headerAlign: "center",
            align: "center",
            width: 60,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.flo.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "798a8663-0f0c-41be-8512-16dd60d5f25e": {
            field: "discount",
            headerName: "DIS",
            headerAlign: "center",
            align: "right",
            width: 50,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.discount)
        },
        "53c8a138-3f8e-486c-a9ba-f5c671065ad7": {
            field: "rapnetprice",
            headerName: "RAP",
            headerAlign: "center",
            align: "right",
            width: 70,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.rapnetprice)
        },
        "39c634f1-2644-4307-acbb-983b4de4229e": {
            field: "price",
            headerName: "PPC",
            headerAlign: "center",
            align: "right",
            width: 70,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.price)
        },
        "7df28e0e-0303-4ff8-a432-9dedb384afa8": {
            field: "total",
            headerName: "TOTAL",
            headerAlign: "center",
            align: "right",
            width: 70,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.total)
        },
        "13d48508-b8c9-4661-8a6c-9fb22a3408a3": {
            field: "measurements",
            headerName: "MEASUREMENTS",
            headerAlign: "center",
            align: "center",
            width: 140,
            renderCell: renderCellExpand,
        },
        "567202e6-c31c-4c19-9998-1cacae05af6e": {
            field: "depth",
            headerName: "DEPTH",
            headerAlign: "center",
            align: "center",
            width: 70,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "daffdd4f-4726-4abc-b8b0-fd4750c874be": {
            field: "lab",
            headerName: "LAB",
            headerAlign: "center",
            align: "center",
            width: 40,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.lab.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "19ce7030-402c-495c-84ac-a29093bdb0ac": {
            field: "locationid",
            headerName: "LOCATION",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "ab3e506e-bddb-456d-b967-922dcee74d56": {
            field: "location",
            headerName: "LOCATION",
            headerAlign: "center",
            align: "center",
            width: 100,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.location.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "f97a0118-3891-4f77-abf7-8636c26d594c": {
            field: "country",
            headerName: "COUNTRY",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "cb7e6add-67ba-4194-ac49-fd0d967db4e8": {
            field: "quality",
            headerName: "QUALITY",
            headerAlign: "center",
            align: "center",
            width: 80,
            renderCell: renderCellExpand,
        },
        "b718f242-4a82-42e7-b98a-40bbf0f67c21": {
            field: "shade",
            headerName: "SHADE",
            headerAlign: "center",
            align: "center",
            width: 60,
            renderCell: renderCellExpand,
        },
        "01e90aca-bdcb-4e8e-80ec-2d7007df8cd3": {
            field: "createdat",
            headerName: "CREATED AT",
            headerAlign: "center",
            align: "center",
            type: "dateTime",
            valueGetter: (params) => {
                if (params.value) {
                    return new Date(params.value);
                }
                return null;
            },
            renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
        },
        "3c62ef48-9538-4df7-9484-a9ae1ba31086": {
            field: "height",
            headerName: "HEIGHT",
            headerAlign: "center",
            align: "center",
            width: 70,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "eed9b7eb-17e4-4ec6-9c9d-c299f885544c": {
            field: "width",
            headerName: "WIDTH",
            headerAlign: "center",
            align: "center",
            width: 70,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "8eaa8a03-d163-436d-8912-51ea06306f44": {
            field: "certificateid",
            headerName: "CERT",
            headerAlign: "center",
            align: "center",
            width: 100,
            renderCell: renderCellExpand,
        },
        "54fbd914-6ce7-44a8-9354-db6125ba1992": {
            field: "tag",
            headerName: "TAG",
            headerAlign: "center",
            align: "center",
            width: 100,
            renderCell: (params) => (!params.value) ? "" : params.value,
        },
        "77e48fa7-d118-4ab8-865b-9b85b32a004f": {
            field: "fancycolour",
            headerName: "F.COLOR",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "ccba9873-174e-4060-963a-9893c3625bb2": {
            field: "fancycolorovertone",
            headerName: "OVERTONE",
            headerAlign: "center",
            align: "center",
            width: 120,
            renderCell: renderCellExpand,
        },
        "c9aa6ee7-30e3-423e-a534-80bb5ef7bbaf": {
            field: "fancycolorintensity",
            headerName: "F.COL.INTENSITY",
            headerAlign: "center",
            align: "center",
            width: 140,
            renderCell: renderCellExpand,
        },
        "706a5cfb-e196-43d1-bbe3-c52aad9a46c1": {
            field: "comment",
            headerName: "COMMENT",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "e7210f4a-6e0a-4591-8428-e6845004ed04": {
            field: "crownheight",
            headerName: "CR.HEIGHT",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "c4e65984-1682-4c1e-812b-8938e9078b2d": {
            field: "crownangle",
            headerName: "CR.ANG",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "0f1de38d-3ae3-4209-a4d5-afe9f3018f22": {
            field: "culetsize",
            headerName: "CULET SZ",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "e3f77521-2c57-46bc-a02b-3c884685d2be": {
            field: "culetcondition",
            headerName: "CULET",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "e5c1f34e-6e1c-4ee8-bb8e-3236716fd1ff": {
            field: "depthpercent",
            headerName: "DEPTH%",
            headerAlign: "center",
            align: "center",
            width: 75,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "e83c2978-9088-49f0-9dc1-bcced73025fd": {
            field: "gridlemin",
            headerName: "GIRDLEMIN",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "cee57bac-9c19-40d5-b51a-51ed913dbf73": {
            field: "intensitylongtitle",
            headerName: "INTENSITYLONGTITLE",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "06d2a589-0d42-4dde-8724-acf2448c839a": {
            field: "laserinscription",
            headerName: "INS",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "dd934505-1865-48cb-878f-f5d3c18af2d5": {
            field: "note",
            headerName: "NOTE",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "61f8a5f2-8516-419a-b6fd-39ef109cc2f4": {
            field: "paviliondepth",
            headerName: "PV.DEPTH",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "70498a64-1f5f-4f03-8910-a6d7851e4aba": {
            field: "tablepercent",
            headerName: "TABLE%",
            headerAlign: "center",
            align: "center",
            width: 75,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "e9028170-e978-4978-a2c9-1889c1821495": {
            field: "gridlecondition",
            headerName: "GIRDLE COND",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "fe8f55f3-358a-4418-bcdf-c3da4b01db67": {
            field: "gridlepercent",
            headerName: "GIRDLE%",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "daf69bba-bb1f-4d54-9dc7-9383ad429585": {
            field: "pavilionangle",
            headerName: "PV.ANGLE",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "ecfdfc0c-6a25-4a6d-9c8f-3406c23410af": {
            field: "white",
            headerName: "WHITE",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "7e356515-7cc5-4cd4-a1a4-a1b909b3b4e3": {
            field: "avgrapnetprice",
            headerName: "AVG RAP PRICE",
            headerAlign: "center",
            width: 140,
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.value),
        },
        "a330b2b8-b9e4-40bb-bb7a-d0e83a717a74": {
            field: "avgdiscount",
            headerName: "AVG DIS",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.value),
        },
        "1ac589a9-ff76-4b9a-9b6e-f0d7951dc0ca": {
            field: "avgprice",
            headerName: "AVG PRICE",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.value),
        },
        "49b8f961-fe52-48ca-afbe-ceab5d7dc740": {
            field: "avgtotal",
            headerName: "AVG TOTAL",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.value),
        },
        "e32fe363-07cc-4307-82d2-82ae1069b5be": {
            field: "age",
            headerName: "AGE",
            headerAlign: "center",
            align: "center",
            valueGetter: (params) => {
                if (params.value)
                    return Utility.ConvertDateToAge(params.value);
                else
                    return null;
            },
            renderCell: (params) => {
                return params.value;
            },
        },
    };

    const prepareColumns = () => {
        let columnNames = [];

        Constants.USER_COLUMN_PERMISSION.forEach(iColPermission => {
            if (columnsData.hasOwnProperty(iColPermission)) {
                const columnData = columnsData[iColPermission];
                if (columnData.field === "status") {
                    columnData.type = "singleSelect";
                    columnData.valueOptions = filterValues;
                    columnData.filterOperators = Utility.combinedFilters();
                }
                columnNames.push(columnData);
                if (columnData.field === "stoneid") {
                    columnNames.push({
                        field: "suratid",
                        headerName: "SURATID",
                        headerAlign: "center",
                        align: "center",
                        width: 80,
                        renderCell: renderCellExpand,
                    })
                } else if (columnData.field === "lab") {
                    if (Constants.USER_COLUMN_PERMISSION.includes("f3223657-c8d2-449c-b2f5-5a54c78401ce")) {
                        columnNames.push({
                            field: "tableinc",
                            headerName: "TABLE INC",
                            headerAlign: "center",
                            align: "right",
                            width: 120,
                            editable: true,
                            renderCell: (params) => (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span style={{ marginRight: '10px' }}>{params.row.tableinc}</span>
                                    {<EditIcon style={{ marginLeft: 10, marginBottom: 3, fontSize: '1rem', }} />}
                                </div>
                            ),
                            cellClassName: (params) => params.row.isEdited && !params.value ? 'yellowCell' : 'lavenderCell',
                            renderEditCell: Utility.getDropDownComponent(tableincOptions, openDropdown, setOpenDropdown, true),
                        })
                    }
                    if (Constants.USER_COLUMN_PERMISSION.includes("f114ad2c-8560-4da7-9b03-03ba6bfe39a5")) {
                        columnNames.push({
                            field: "sideinc",
                            headerName: "SIDE INC",
                            headerAlign: "center",
                            align: "right",
                            width: 120,
                            editable: true,
                            renderCell: (params) => (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span style={{ marginRight: '10px' }}>{params.row.sideinc}</span>
                                    {<EditIcon style={{ marginLeft: 10, marginBottom: 3, fontSize: '1rem', }} />}
                                </div>
                            ),
                            cellClassName: (params) => params.row.isEdited && !params.value ? 'yellowCell' : 'lavenderCell',
                            renderEditCell: Utility.getDropDownComponent(sideincOptions, openDropdown, setOpenDropdown, true),
                        })
                    }
                    if (Constants.USER_COLUMN_PERMISSION.includes("e993a4f7-7c50-4d83-abae-fccc03382742")) {
                        columnNames.push({
                            field: "h_and_a",
                            headerName: "H&A",
                            headerAlign: "center",
                            align: "right",
                            width: 120,
                            editable: true,
                            renderCell: (params) => (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span style={{ marginRight: '10px' }}>{params.row.h_and_a}</span>
                                    {<EditIcon style={{ marginLeft: 10, marginBottom: 3, fontSize: '1rem', }} />}
                                </div>
                            ),
                            cellClassName: (params) => params.row.isEdited && !params.value ? 'yellowCell' : 'lavenderCell',
                            renderEditCell: Utility.getDropDownComponent(hnaOptions, openDropdown, setOpenDropdown, false),
                        })
                    }
                    if (Constants.USER_COLUMN_PERMISSION.includes("f2fe7666-6489-40ce-b4b7-040c68c88bf3")) {
                        columnNames.push({
                            field: "eyeclean",
                            headerName: "EYE CLEAN",
                            headerAlign: "center",
                            align: "right",
                            width: 120,
                            editable: true,
                            renderCell: (params) => (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span style={{ marginRight: '10px' }}>{params.row.eyeclean}</span>
                                    {<EditIcon style={{ marginLeft: 10, marginBottom: 3, fontSize: '1rem', }} />}
                                </div>
                            ),
                            cellClassName: (params) => params.row.isEdited && !params.value ? 'yellowCell' : 'lavenderCell',
                            renderEditCell: Utility.getDropDownComponent(eyecleanOptions, openDropdown, setOpenDropdown, false),
                        })
                    }
                    if (Constants.USER_COLUMN_PERMISSION.includes("b38b9fdf-bfb8-43c6-82a2-1e366fa71523")) {
                        columnNames.push({
                            field: "tinge",
                            headerName: "TINGE",
                            headerAlign: "center",
                            align: "right",
                            width: 120,
                            editable: true,
                            type: "singleSelect",
                            valueOptions: Constants.uniqueFilterValues.tinge.sort((a, b) => a.seq - b.seq).map(option => option.value),
                            filterOperators: Utility.combinedFilters(),
                            renderCell: (params) => (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span style={{ marginRight: '10px' }}>{params.row.tinge}</span>
                                    {<EditIcon style={{ marginLeft: 10, marginBottom: 3, fontSize: '1rem' }} />}
                                </div>
                            ),
                            cellClassName: (params) => params.row.isEdited && !params.value ? 'yellowCell' : 'lavenderCell',
                            renderEditCell: Utility.getDropDownComponent(tingeOptions, openDropdown, setOpenDropdown, false),
                        })
                    }
                    if (Constants.USER_COLUMN_PERMISSION.includes("db078198-4416-4d53-b3d0-70d3a5418f65")) {
                        columnNames.push({
                            field: "open",
                            headerName: "OPEN",
                            headerAlign: "center",
                            align: "right",
                            width: 120,
                            editable: true,
                            renderCell: (params) => (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span style={{ marginRight: '10px' }}>{params.row.open}</span>
                                    {<EditIcon style={{ marginLeft: 10, marginBottom: 3, fontSize: '1rem', }} />}
                                </div>
                            ),
                            cellClassName: (params) => params.row.isEdited && !params.value ? 'yellowCell' : 'lavenderCell',
                            renderEditCell: Utility.getDropDownComponent(openOptions, openDropdown, setOpenDropdown, false),
                        })
                    }
                    if (Constants.USER_COLUMN_PERMISSION.includes("c95089ee-166d-4783-817c-2638f6d40df1")) {
                        columnNames.push({
                            field: "milky",
                            headerName: "MILKY",
                            headerAlign: "center",
                            align: "right",
                            width: 120,
                            editable: true,
                            type: "singleSelect",
                            valueOptions: Constants.uniqueFilterValues.milky.sort((a, b) => a.seq - b.seq).map(option => option.value),
                            filterOperators: Utility.combinedFilters(),
                            renderCell: (params) => (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span style={{ marginRight: '10px' }}>{params.row.milky}</span>
                                    {<EditIcon style={{ marginLeft: 10, marginBottom: 3, fontSize: '1rem', }} />}
                                </div>
                            ),
                            cellClassName: (params) => params.row.isEdited && !params.value ? 'yellowCell' : 'lavenderCell',
                            renderEditCell: Utility.getDropDownComponent(milkyOptions, openDropdown, setOpenDropdown, false),
                        })
                    }
                    if (Constants.USER_COLUMN_PERMISSION.includes("2a6475ff-481f-48c6-9e92-3ede0b97d7c0")) {
                        columnNames.push({
                            field: "luster",
                            headerName: "LUSTER",
                            headerAlign: "center",
                            align: "right",
                            width: 120,
                            editable: true,
                            renderCell: (params) => (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span style={{ marginRight: '10px' }}>{params.row.luster}</span>
                                    {<EditIcon style={{ marginLeft: 10, marginBottom: 3, fontSize: '1rem', }} />}
                                </div>
                            ),
                            cellClassName: (params) => params.row.isEdited && !params.value ? 'yellowCell' : 'lavenderCell',
                            renderEditCell: Utility.getDropDownComponent(lusterOptions, openDropdown, setOpenDropdown, false),
                        })
                    }
                    if (Constants.USER_COLUMN_PERMISSION.includes("556ae429-3605-4df4-88d8-b5223fc2e2fb")) {
                        columnNames.push({
                            field: "tableblack",
                            headerName: "TABLE BLACK",
                            headerAlign: "center",
                            align: "center",
                            width: 120,
                            editable: false,
                            type: "boolean",
                            cellClassName: (params) =>
                                params.row.isEdited && (params.value === undefined || params.value === null)
                                    ? 'yellowCell'
                                    : 'lavenderCell',
                            renderCell: (params) => {
                                if (params.value === true) return '✔';
                                if (params.value === false) return '✖';
                                return '—'; // For null or undefined
                            }
                        })
                    }
                    if (Constants.USER_COLUMN_PERMISSION.includes("5c70d1ca-2a7b-4660-8160-0beff7ad1150")) {
                        columnNames.push({
                            field: "sideblack",
                            headerName: "SIDE BLACK",
                            headerAlign: "center",
                            align: "center",
                            width: 120,
                            editable: false,
                            type: "boolean",
                            cellClassName: (params) =>
                                params.row.isEdited && (params.value === undefined || params.value === null)
                                    ? 'yellowCell'
                                    : 'lavenderCell',
                            renderCell: (params) => {
                                if (params.value === true) return '✔';
                                if (params.value === false) return '✖';
                                return '—'; // For null or undefined
                            }
                        })
                    }
                } else if (columnData.field === "shape") {
                    if (Constants.USER_COLUMN_PERMISSION.includes("b9f18661-4f47-4a56-a47b-51d8baf8e071")) {
                        columnNames.push({
                            field: "labshape",
                            headerName: "LAB SHAPE",
                            headerAlign: "center",
                            align: "center",
                            width: 90,
                            renderCell: renderCellExpand,
                        })
                    }
                }
            }
        });
        return columnNames;
    };

    const rows = stockData;
    const columns = prepareColumns();

    const allowed = Utility.isReadAllowed(stockTallyPermission);

    // Color Scheme Drop Down Button
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseButton = () => {
        setAnchorEl(null);
    };

    const CustomToolbar = () => {
        return (
            <GridToolbarContainer
                sx={{
                    display: "flex",
                    alignItems: "center",
                    marginHorizontal: "5px",
                    "&.MuiDataGrid-toolbarContainer": {
                        padding: "0px 4px !important",
                    },
                }}
            >
                <CommonStoneSelection
                    title={"Enter multiple Stone Ids"}
                    handleSelection={handleSelection}
                    bgColor='#454545'
                    buttonDisabled={rows.length === 0}
                />
                <Tooltip title={"Start Scan"}>
                    <IconButton
                        color={"success"}
                        onClick={() => startScanning()}
                        disabled={stockData.length === 0}
                    >
                        {<VscRunAll />}
                    </IconButton>
                </Tooltip>

                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarExport />
                <Box sx={{ flexGrow: 1, display: { md: "none", lg: "block" } }} />
                {stockLoader ? (
                    <CircularProgress sx={{ cursor: "pointer", width: "1.8rem !important" }} />
                ) : (
                    <Tooltip title="Reload List">
                        <RefreshOutlinedIcon
                            onClick={() => handleSearch()}
                            color="primary"
                            fontSize="large"
                            sx={{ cursor: "pointer", width: "1.8rem" }}
                        />
                    </Tooltip>
                )}
                {Utility.isAddAllowed(stockTallyPermission) ? (
                    <Tooltip title="Download Sample Stock Tally Grading">
                        <a
                            href="/demo_excel/SampleStockTallyGrading.csv"
                            download="SampleStockTallyGrading.csv"
                            style={{ color: "red", marginRight: "10px", marginLeft: "10px" }}
                        >
                            <BackupTable size={25} />
                        </a>
                    </Tooltip>
                ) : null}

                {Utility.isAddAllowed(stockTallyPermission) ? (
                    <Tooltip title="Upload Stone Tag">
                        <Box sx={{
                            "& .Mui-disabled": {
                                backgroundColor: "rgba(0, 0, 0, 0.12) !important",
                                color: "rgba(0, 0, 0, 0.26) !important"
                            }
                        }}>
                            <LoadingButton
                                color="info"
                                variant="outlined"
                                size="small"
                                sx={{ ml: "3px" }}
                                component="label"
                                loading={uploadLoader}
                                loadingPosition="start"
                                startIcon={<UploadFileIcon size="large" />}
                                disabled={stockLoader}
                            >
                                Upload
                                <input
                                    id="file-input"
                                    hidden
                                    accept=".csv"
                                    type="file"
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (file) {
                                            setUploadLoader(true);
                                            handleUpload(file);
                                        }
                                    }}
                                    onClick={(e) => {
                                        handleClear()
                                    }}
                                />
                            </LoadingButton>
                        </Box>
                    </Tooltip>
                ) : null}

                {Utility.isUpdateAllowed(stockTallyPermission) ? (
                    <LoadingButton
                        color="success"
                        variant="contained"
                        size="small"
                        sx={{ ml: "5px" }}
                        onClick={() => handleApply()}
                        disabled={selectionModel.length === 0 || stockLoader}
                        loading={applyLoader}
                        loadingPosition="start"
                        startIcon={<TaskAltIcon size="large" />}
                    >
                        Apply
                    </LoadingButton>
                ) : null}
                <GridToolbarQuickFilter debounceMs={500} />
            </GridToolbarContainer>
        )
    }

    return (
        !allowed ? <NoPermission /> :
            <div>
                <Container maxWidth="xxl">

                    {stockData ? (
                        <TabMenuSnackbar
                            show={uploadSuccessSnackbar}
                            message={
                                stockData.length !== 0
                                    ? `File loaded Successfully`
                                    : `File could not be loaded`
                            }
                            variant={stockData.length !== 0 ? "success" : "error"}
                            autoHide={Constants.SnackBarCloseTimer}
                            title={stockData.length !== 0 ? "Success" : "Error"}
                            handleClose={() => setUploadSuccessSnackbar(false)}
                        />
                    ) : null}

                    <TabMenuSnackbar
                        show={showSnackbar}
                        message={snackbarMessage}
                        variant={snackbarVariant}
                        autoHide={Constants.SnackBarCloseTimer}
                        title={snackbarVariant === "success" ? "Success" : "Failed"}
                        handleClose={() => setShowSnackbar(false)}
                    />

                    {showStoneDetailModal ? (
                        <StoneDetailModal
                            show={showStoneDetailModal}
                            stoneId={stoneId}
                            handleClose={handleClose}
                        />
                    ) : null}
                    {showKapanDetailModal ? (
                        <KapanHistoryModal
                            show={showKapanDetailModal}
                            kapanId={kapanId}
                            close={() => setShowKapanDetailModal(false)}
                        />
                    ) : null}

                    <TabMenuSnackbar
                        show={successSnackbar}
                        message={'Stone Updated Successfully'}
                        variant={"success"}
                        autoHide={Constants.SnackBarCloseTimer}
                        title={"Success"}
                        handleClose={() => setSuccessSnackbar(false)}
                    />

                    <TabMenuSnackbar
                        show={errorSnackbar}
                        message={Constants.APiFailErrorMessage}
                        variant={"error"}
                        autoHide={Constants.SnackBarCloseTimer}
                        title={"Failed"}
                        handleClose={() => setErrorSnackbar(false)}
                    />

                    <TabMenuSnackbar
                        show={alertSnackbar}
                        message={alertMessage}
                        variant={"error"}
                        autoHide={Constants.SnackBarCloseTimer}
                        title={"Failed"}
                        handleClose={() => setAlertSnackbar(false)}
                    />

                    <TabMenuSnackbar
                        show={showSnackbar}
                        message={snackbarMessage}
                        variant={snackbarVariant}
                        autoHide={Constants.SnackBarCloseTimer}
                        title={snackbarVariant === "success" ? "Success" : (snackbarVariant === "error" ? "Failed" : "Warning")}
                        handleClose={() => setShowSnackbar(false)}
                    />
                    <Box display={"flex"} margin={"4px 8px"} justifyContent='space-between' marginTop={"1px"}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-start",
                                flexGrow: 1,
                                flexBasis: 0,
                                overflow: "hidden",
                                color: "black",
                                fontWeight: "normal",
                                px: 1,
                                textAlign: "center",
                                paddingTop: "10px",
                                paddingBottom: "21px",
                            }}
                        >
                            <Stack
                                direction="row"
                                spacing={2}
                                useFlexGap
                                flexWrap="wrap"
                                sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    justifyContent: "flex-start",
                                }}
                            >
                                <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
                                    No of Stones: <b>{noOfSelectedStones}</b>
                                </Typography>
                                <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
                                    Total Weight: <b>{selectedTotalSize}</b>
                                </Typography>
                                <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
                                    Total Price: <b>{selectedtotalPrice}</b>
                                </Typography>
                                <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
                                    Avg Price: <b>{selectedavgPrice}</b>
                                </Typography>
                                <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
                                    Avg Discount: <b>{selectedAvgDiscount}</b>
                                </Typography>
                            </Stack>
                        </Box>

                        <Box
                            sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "15px",
                                alignItems: "center",
                                justifyContent: "flex-start",
                            }}
                        >
                            <Box
                                id="demo-customized-button"
                                aria-controls={open ? 'demo-customized-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                variant="outlined"
                                disableElevation
                                onClick={handleClick}
                                endIcon={<KeyboardArrowDownIcon />}
                                sx={{
                                    color: "#454545",
                                    borderColor: "#454545",
                                    borderRadius: "4px",
                                    border: "1px solid black",
                                    padding: "5px",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "4rem",
                                }}
                            >
                                <img
                                    src={colourchart}
                                    alt="Color Scheme"
                                    style={{ height: "24px", width: "24px" }}
                                />
                                <KeyboardArrowDownIcon />
                            </Box>
                            <StyledMenu
                                id="demo-customized-menu"
                                MenuListProps={{
                                    'aria-labelledby': 'demo-customized-button',
                                    style: { maxHeight: 250 },
                                }}
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleCloseButton}
                            >
                                <MenuItem onClick={handleCloseButton} disableRipple>
                                    <span style={{ height: "15px", width: "15px", backgroundColor: "#F9F08D", borderRadius: 20, margin: 10 }}></span>NEW
                                </MenuItem>
                                <MenuItem onClick={handleCloseButton} disableRipple>
                                    <span style={{ height: "15px", width: "15px", backgroundColor: "#7EAEEE", borderRadius: 20, margin: 10 }}></span>LAB
                                </MenuItem>
                                <MenuItem onClick={handleCloseButton} disableRipple>
                                    <span style={{ height: "15px", width: "15px", backgroundColor: "#FCCD91", borderRadius: 20, margin: 10 }}></span>RE-LAB
                                </MenuItem>
                                <MenuItem onClick={handleCloseButton} disableRipple>
                                    <span style={{ height: "15px", width: "15px", backgroundColor: "#FFFFCC", borderRadius: 20, margin: 10 }}></span>RE-CHECK
                                </MenuItem>
                                <MenuItem onClick={handleCloseButton} disableRipple>
                                    <span style={{ height: "15px", width: "15px", backgroundColor: "#B8ACF6", borderRadius: 20, margin: 10 }}></span>RE-CHECK_SENT
                                </MenuItem>
                                <MenuItem onClick={handleCloseButton} disableRipple>
                                    <span style={{ height: "15px", width: "15px", backgroundColor: "#388BFF", borderRadius: 20, margin: 10 }}></span>RE-CHECK_DONE
                                </MenuItem>
                                <MenuItem onClick={handleCloseButton} disableRipple>
                                    <span style={{ height: "15px", width: "15px", backgroundColor: "#E0E88C", borderRadius: 20, margin: 10 }}></span>MIX
                                </MenuItem>
                                <MenuItem onClick={handleCloseButton} disableRipple>
                                    <span style={{ height: "15px", width: "15px", backgroundColor: "#FBDEDE", borderRadius: 20, margin: 10 }}></span>AVAILABLE_APPROVAL_PENDING
                                </MenuItem>
                                <MenuItem onClick={handleCloseButton} disableRipple>
                                    <span style={{ height: "15px", width: "15px", backgroundColor: "#000000", borderRadius: 20, margin: 10 }}></span>AVAILABLE
                                </MenuItem>
                                <MenuItem onClick={handleCloseButton} disableRipple>
                                    <span style={{ height: "15px", width: "15px", backgroundColor: "#B6B9D6", borderRadius: 20, margin: 10 }}></span>HOLD
                                </MenuItem>
                                <MenuItem onClick={handleCloseButton} disableRipple>
                                    <span style={{ height: "15px", width: "15px", backgroundColor: "#CAF7F6", borderRadius: 20, margin: 10 }}></span>MEMO_OUT
                                </MenuItem>
                                <MenuItem onClick={handleCloseButton} disableRipple>
                                    <span style={{ height: "15px", width: "15px", backgroundColor: "#FEBD7D", borderRadius: 20, margin: 10 }}></span>IN_TRANSIT
                                </MenuItem>
                            </StyledMenu>
                        </Box>
                    </Box>
                    <Box
                        key={rows}
                        sx={{
                            backgroundColor: '#fff',
                            color: '#000',
                            width: "100%",
                            position: "relative",
                            "& .MuiTablePagination-selectLabel": {
                                marginTop: "15px",
                            },
                            "& .MuiTablePagination-displayedRows": {
                                marginTop: "15px",
                            },
                            "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                fontWeight: Constants.defaultFontWeight,
                            },
                            "& .css-cc8tf1": {
                                fontWeight: Constants.defaultFontWeight,
                            },
                            height: '69vh',
                            "& .lavenderCell": {
                                color: "#080808",
                                backgroundColor: "#D8BFD8",
                            },
                            "& .yellowCell": {
                                color: "#080808",
                                backgroundColor: "#F1E68C !important",
                            },
                        }}
                    >
                        <StyledDataGrid
                            disableRowSelectionOnClick={true}
                            localeText={{ noRowsLabel: "No Record Found" }}
                            sx={{ height: "69vh", fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight, }}
                            slots={{
                                toolbar: CustomToolbar,
                            }}
                            rows={rows}
                            style={{}}
                            sortModel={sortModel}
                            onSortModelChange={(newModel) => setSortModel(newModel)}
                            density="compact"
                            columns={columns}
                            getRowId={(row) => row.stoneid}
                            checkboxSelection={true}
                            processRowUpdate={processRowUpdate}
                            onProcessRowUpdateError={handleProcessRowUpdateError}
                            onRowSelectionModelChange={(newSelectionModel) => {
                                setSelectionModel(newSelectionModel);
                            }}
                            loading={stockLoader}
                            rowSelectionModel={selectionModel}
                            initialState={{
                                columns: {
                                    columnVisibilityModel: {
                                        // Hide columns id, the other columns will remain visible
                                        locationid: false,
                                        kapanid: false,
                                        country: false,
                                        quality: false,
                                        shade: false,
                                        repacode: false,
                                        createdat: false,
                                        height: false,
                                        width: false,
                                        packetid: false,
                                        crownheight: false,
                                        crownangle: false,
                                        culetsize: false,
                                        culetcondition: false,
                                        depthpercent: false,
                                        gridlemin: false,
                                        intensitylongtitle: false,
                                        note: false,
                                        paviliondepth: false,
                                        gridlecondition: false,
                                        gridlepercent: false,
                                        pavilionangle: false,
                                        white: false,
                                    },
                                },
                                pagination: {
                                    paginationModel: Constants.pageSize,
                                },
                            }}
                            pageSizeOptions={Constants.pageSizeOptions}
                            pagination
                            slotProps={{
                                toolbar: {
                                    showQuickFilter: true,
                                    quickFilterProps: {
                                        debounceMs: 500,
                                    },
                                },
                            }}
                            apiRef={apiRef}
                            onCellClick={handleCellClick}
                            editMode="cell"
                        />
                    </Box>
                </Container>
            </div >
    );
}
